export const CLOUD_CAPABILITY_VARIABLE_TYPE = {
    STRING: 'string',
};

export const CLOUD_CAPABILITY_VARIABLE_STRING_PLACEHOLDER = 'Enter value';
